const visualizerVehicleFields = ['Year', 'Make', 'Model', 'Submodel'];

export const visualizeVehicle = ({ apiKey, autoSyncConfig = {}, vehicleString, wheelMpn }) => {
  if (!apiKey) {
    console.error('No api key found');
  }

  if (!vehicleString) {
    return;
  }
  const visualizer = window.initVvsExpress?.({
    apiUrl: 'https://api.autosyncstudio.com/',
    apiKey,
    ...autoSyncConfig,
  });

  if (!visualizer) {
    return;
  }

  visualizer.loadVehicleByDescription(vehicleString).catch((err) => {
    visualizer.setHeight('0px');
    console.warn(`Failed to visualize the '${vehicleString}' vehicle. ${err.message}`);
  });

  if (wheelMpn) {
    visualizer.loadWheelByPn(wheelMpn).catch((err) => {
      visualizer.setHeight('0px');
      console.warn(`Failed to visualize the '${wheelMpn}' wheel. ${err.message}`);
    });
  }

  return visualizer;
};

export const getVehicleString = () => {
  const vehicle = window.Convermax.getVehicle();

  const isVehicleSelected = Object.keys(vehicle).length;
  if (!isVehicleSelected) {
    return null;
  }

  return visualizerVehicleFields
    .map((field) => vehicle[field])
    .filter(Boolean)
    .join(' ');
};
